import { lazy } from 'react';
export const Solutions = lazy(() => import('@/Platform/SolutionList'));
export const Users = lazy(() => import('@/Portal/Users/Users'));
export const RolePermissions = lazy(() => import('@/Portal/RolePermissions'));
export const AuditLog = lazy(() => import('@/Portal/AuditLog/AuditLog'));
export const Settings = lazy(() => import('@/Portal/Settings/Settings'));
export const FileProcessing = lazy(() => import('@/Portal/FileProcessing/FileProcessing'));
export const BulkWizard = lazy(() => import('@/Portal/BulkOperations/BulkWizard'));
